'use client';
import './style.sass';

import {
    listPath,
    listTitle,
    listStages,
    listSolutions,
    listSolutionsRoles,
    listMarker,
    listMarkerStages,
    iconsBlock,
    listCompetitions,
    listMedia,
    listResults,
    targetList,
} from './constans';
import TitleCase from '../../case-components/title-case';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';
import Target from '../reusable-components/target';
import LayoutPage from '../reusable-components/layouts-component__aimed/layout-page';
import Solution from '../reusable-components/layouts-component__aimed/solution';
import Marker from '../reusable-components/layouts-component__aimed/marker';
import MarkerText from '../reusable-components/layouts-component__aimed/marker-text';
import Challenge from '../reusable-components/layouts-component__aimed/challenge';
import Competition from '../reusable-components/layouts-component__aimed/competition';
import UniqueMarker from '../reusable-components/layouts-component__aimed/unique-marker';
import Result from '../reusable-components/layouts-component__aimed/result';
import Team from '../reusable-components/layouts-component__aimed/team';
import Review from '../reusable-components/layouts-component__aimed/review';
import CloudSystem from '../reusable-components/layouts-component__aimed/cloud-system';

const Aimed = () => {
    const casePathname = '/cases/development/aimed';
    const adjacentCase = getAdjacentCase(casePathname);

    return (
        <section>
            <TitleCase
                img="/images/pic/aimed/aimed.png"
                listPath={listPath}
                listTitle={listTitle}
                caseName="aimed"
            />
            <Target title={targetList.title} description={targetList.description} />
            <LayoutPage listStages={listStages} />
            <Solution list={listSolutions} listRoles={listSolutionsRoles} />
            <Marker />
            <MarkerText list={listMarker} listStages={listMarkerStages} />
            <CloudSystem />
            <Challenge list={iconsBlock} />
            <Competition list={listCompetitions} />
            <UniqueMarker />
            <Result list={listResults} listMedia={listMedia} />
            <Team />
            <Review />
            {adjacentCase && (
                <NextProject
                    NextProject={{
                        nextProjectTitle: adjacentCase.case.title,
                        nextProjectImg: adjacentCase.case.image,
                        nextProjectLink: adjacentCase.case.router,
                        nextProjectText: adjacentCase.case.description,
                        nextProjectLabel: adjacentCase.label,
                    }}
                />
            )}
        </section>
    );
};

export default Aimed;
